import React, { FC } from 'react';

import { useFlag } from '@modernloop/shared/feature-flag';

import RedirectWithQueryParams from 'src/components/Link/RedirectWithQueryParams';

import { useIsOrgSetupRequiredCompleted } from 'src/hooks/useOrgRequiredSetup';

import LoadingScreen from 'src/shared/components/base/screenLoaders/LoadingScreen';

const RPOrgIntegrationSetupGuard: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const newOnboardingExperience = useFlag('user_new_onboarding_experience');

  const { completed, loading } = useIsOrgSetupRequiredCompleted();
  if (newOnboardingExperience) {
    /**
     * If fetching permission status, show loading screen
     */
    if (loading) {
      return <LoadingScreen />;
    }

    /**
     * Check for the ORG onboarded mandatory statuses
     */
    if (!completed) {
      return <RedirectWithQueryParams to="/onboarding" />;
    }
  }
  return <>{children}</>;
};

export default RPOrgIntegrationSetupGuard;
